import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import ProductDetail from "./pages/ProductDetail";
import SearchPage from "./pages/Search";
import Submit from "./pages/Submit";
import Latest from "./pages/Latest";
import About from "./pages/About";
import Opportunities from "./pages/Opportunities";
import NotFound from "./pages/NotFound";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route
                        path="/category/:slug"
                        element={<CategoryDetail />}
                    />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/submit" element={<Submit />} />
                    <Route path="/latest" element={<Latest />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/opportunities" element={<Opportunities />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
            <Toaster richColors position="top-center" />
        </BrowserRouter>
    );
}

export default App;
